import Expense from "../../entities/expense";

/**
 * Expense actions
 *
 * Call order:
 *
 * EXPENSE_SAVE_QUEUE:	adds the item to the save queue
 * --> EXPENSE_SAVE:	modifies the state
 * --> EXPENSE_SAVE_SUCCESS: if all went well
 * --> EXPENSE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail EXPENSE_SAVE_QUEUE is during the call to EXPENSE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const EXPENSE_FETCH_ONE_QUEUE: any = 'EXPENSE_FETCH_ONE_QUEUE';
export const EXPENSE_FETCH_SUCCESS: any = 'EXPENSE_FETCH_SUCCESS';
export const EXPENSE_FETCH_FAILURE: any = 'EXPENSE_FETCH_FAILURE';
export const EXPENSE_FETCH_ONE_SUCCESS: any = 'EXPENSE_FETCH_ONE_SUCCESS';
export const EXPENSE_FETCH_ONE_FAILURE: any = 'EXPENSE_FETCH_ONE_FAILURE';

export const EXPENSE_SAVE: any = 'EXPENSE_SAVE';
export const EXPENSE_SAVE_QUEUE: any = 'EXPENSE_SAVE_QUEUE';
export const EXPENSE_SAVE_SUCCESS: any = 'EXPENSE_SAVE_SUCCESS';
export const EXPENSE_SAVE_FAILURE: any = 'EXPENSE_SAVE_FAILURE';

export const EXPENSE_SAVE_MANY: any = 'EXPENSE_SAVE_MANY';
export const EXPENSE_SAVE_MANY_QUEUE: any = 'EXPENSE_SAVE_MANY_QUEUE';
export const EXPENSE_SAVE_MANY_SUCCESS: any = 'EXPENSE_SAVE_MANY_SUCCESS';
export const EXPENSE_SAVE_MANY_FAILURE: any = 'EXPENSE_SAVE_MANY_FAILURE';

export const EXPENSE_REMOVE: any = 'EXPENSE_REMOVE';
export const EXPENSE_REMOVE_QUEUE: any = 'EXPENSE_REMOVE_QUEUE';
export const EXPENSE_REMOVE_SUCCESS: any = 'EXPENSE_REMOVE_SUCCESS';
export const EXPENSE_REMOVE_FAILURE: any = 'EXPENSE_REMOVE_FAILURE';

export const EXPENSE_RESTORE: any = 'EXPENSE_RESTORE';
export const EXPENSE_RESTORE_QUEUE: any = 'EXPENSE_RESTORE_QUEUE';
export const EXPENSE_RESTORE_SUCCESS: any = 'EXPENSE_RESTORE_SUCCESS';
export const EXPENSE_RESTORE_FAILURE: any = 'EXPENSE_RESTORE_FAILURE';

export const EXPENSE_RESTORE_MANY: any = 'EXPENSE_RESTORE_MANY';
export const EXPENSE_REMOVE_MANY: any = 'EXPENSE_REMOVE_MANY';

/* Fetch actions */
export const fetchExpenseSuccess = (expenses: Expense[], partial: boolean, lastFetch: number) => ({type: EXPENSE_FETCH_SUCCESS, expenses, partial, lastFetch});
export const fetchExpenseFailure = (err: any) => {
		console.error('ExpenseAction: fetchExpenseFailure', err);
		return {type: EXPENSE_FETCH_FAILURE, err};
};
export const fetchOneExpenseQueue = (expenseId: string) => ({type: EXPENSE_FETCH_ONE_QUEUE, expenseId});
export const fetchOneExpenseSuccess = (expense: Expense) => ({type: EXPENSE_FETCH_ONE_SUCCESS, expense});
export const fetchOneExpenseFailure = (id: string, err: any) => {
		console.error('ExpenseAction: fetchOneExpenseFailure', err);
		return {type: EXPENSE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveExpense = (expense: Expense) => {
    // console.debug('⮂ EXPENSE_SAVE action', expense?.id);
    return {type: EXPENSE_SAVE, expense};
}
export const saveExpenseQueue = (expense: Expense, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ EXPENSE_SAVE_QUEUE action', expense?.id);
    return {type: EXPENSE_SAVE_QUEUE, expense, onQueued};
}
export const saveExpenseSuccess = (expense: Expense) => {
    // console.debug('⮂ EXPENSE_SAVE_SUCCESS action', expense?.id);
    return {type: EXPENSE_SAVE_SUCCESS, expense};
}
export const saveExpenseFailure = (expense: Expense, status: number, message: string) => {
    console.warn(`⮂ EXPENSE_SAVE_FAILURE error saving expense: HTTP ${status}: ${message}`, expense?.id);
    return {type: EXPENSE_SAVE_FAILURE, expense, status, message};
};

/* SaveMany actions */
export const saveManyExpenses = (expenses: Expense[]) => {
    // console.debug('⮂ EXPENSE_SAVE_MANY action', expenses?.map(expense => expense?.id).join(','));
    return {type: EXPENSE_SAVE_MANY, expenses};
}
export const saveManyExpensesQueue = (expenses: Expense[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ EXPENSE_SAVE_MANY_QUEUE action', expenses?.map(expense => expense.id).join(','));
    return {type: EXPENSE_SAVE_MANY_QUEUE, expenses, onQueued};
}

export const saveManyExpensesSuccess = (expenses: Expense[]) => {
    // console.debug('⮂ EXPENSE_SAVE_MANY_SUCCESS action', expenses?.map(expense => expense.id).join(','));
    return {type: EXPENSE_SAVE_MANY_SUCCESS, expenses};
}
export const saveManyExpensesFailure = (expenses: Expense[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_EXPENSES_FAILURE Error saving expenses: HTTP ${status}: ${message}`, expenses?.map(expense => expense.id).join(','));
		return {type: EXPENSE_SAVE_MANY_FAILURE, expenses, status, message};
};

/* Remove actions */
export const removeExpense = (expense: Expense) => ({ type: EXPENSE_REMOVE, expense });
export const removeExpenseQueue = (expense: Expense) => ({ type: EXPENSE_REMOVE_QUEUE, expense });
export const removeExpenseSuccess = (expense: Expense) => ({ type: EXPENSE_REMOVE_SUCCESS, expense });
export const removeExpenseFailure = (expense: Expense, status: number, message: string) => {
	console.error(`Redux: removeExpenseFailure Error removing expense: HTTP ${status}: ${message}`);
	return ({ type: EXPENSE_REMOVE_FAILURE, expense, status, message });
};

/* Restore actions */
export const restoreExpense = (expense: Expense) => ({ type: EXPENSE_RESTORE, expense });
export const restoreExpenseQueue = (expense: Expense) => ({ type: EXPENSE_RESTORE_QUEUE, expense });
export const restoreExpenseSuccess = (expense: Expense) => ({ type: EXPENSE_RESTORE_SUCCESS, expense });
export const restoreExpenseFailure = (expense: Expense, status: number, message: string) => {
	console.error(`Redux: restoreExpenseFailure Error restoring expense: HTTP ${status}: ${message}`);
	return ({ type: EXPENSE_RESTORE_FAILURE, expense, status, message });
};

/* RestoreMany actions */
export const restoreManyExpenses = (expenses: Expense[]) => ({ type: EXPENSE_RESTORE_MANY, expenses });

/* RemoveMany actions */
export const removeManyExpenses = (expenses: Expense[]) => ({ type: EXPENSE_REMOVE_MANY, expenses });